import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import axios from 'axios';
import { currentUser, users } from '../../services/userURLs';
import { currentUserReviews } from '../../services/reviewURLs';
import { customerPlan } from '../../services/paymentURLs';


import ReviewsList from './MyReviewsList';
import './MyReviews.css';

class MyReviews extends Component {
  state = {
    reviews: [],
    userId: null,
    movieId: null,
    reviewer: '',
    photo: '',
    email: '',
    rating: null,
    textBody: '',
    name: '',
    premium: 0,
    stripeId: '',
    currUserId: null
  };

  componentDidMount = () => {
    console.log(this.props, "my reviews props")

    axios.get(currentUser, { withCredentials: true })
      .then(response => {
        axios.get(`${users}/${response.data[0].id}`)
          .then(userResponse => {
            const { photo, stripeId, twitterId } = userResponse.data;
            let newPhoto;
            //if twitterId
            if(twitterId) {
              newPhoto = `${photo.substr(0, userResponse.data.photo.length - 11)}.jpg`
            } else {
              newPhoto = photo;
            }
            // if stripeId
            if(stripeId) {
              axios
              .post(customerPlan, {
                stripeId
              })
              .then(planRes => {
                // console.log(planRes);
                if (planRes.data.premium) {
                  this.setState({
                    stripeId,
                    premium: 1,
                    currUserId: userResponse.data.id
                  });
                }
              })
              .catch(error => {
                this.setState({
                  stripeId: '',
                  premium: 0, 
                  currUserId: userResponse.data.id
                });
              });
            }
            else {
              this.setState({premium: 0});
            }
            this.setState({reviewer: userResponse.data.name, photo: userResponse.data.photo})
          })
          .catch(error => {
            this.setState({error: true, errorMessage: error.message});
          })
      })
      .catch(error => {
        this.setState({error: true, errorMessage: error.message});
      })
      
      if(this.props.location.state) {
        this.setState({reviews: this.props.location.state.detail}, () => {
          console.log(this.state.reviews)
        })
      }
      else {
        this.setState({ reviews: []});
      }
  };

  render() {
    console.log("myreviews props", this.props, "\n myreviews state", this.state);
    // console.log('MyReviews: ', this.state.reviews);
    return (
      <Container className="movieRevWrapper background-color">
        {/* start of Grid A */}
        <Row>
          <Col lg="3">
            <div className="placeholder">
              <a href="/myreviews">
                <img
                  className="myreviews-avatar img-responsive mb-3 "
                  src={this.state.photo}
                  alt="avatar"
                  style={{ height: 150, width: 150 }}
                />
              </a>

              <ul className="list-group list-group-flush text-left">
                <li className="list-group-item pl-3 bg-white">
                  <span className="badge badge-light">{this.state.name}</span>
                </li>
              </ul>
            </div>
          </Col>
          {/* 12 grid B */}
          <Col lg="9" className="secondCol">
            <div className="bodyRev">
              <div className="My-Reviews">
                <header className="sidebar" />
                <div className="reviews-section text-left">
                  <ReviewsList
                    getReleaseYear={this.props.getReleaseYear}
                    reviewslist={this.state.reviews}
                    premium={this.state.premium}
                  />
                </div>
              </div>
            </div>
            {/* end of Grid B */}
          </Col>
        </Row>
        {/* end of 12 Grid A */}
      </Container>
    );
  }
}

export default MyReviews;
